import React from "react";
import styled from "styled-components";

/**
 * ステップフロー本文で使う定型パーツ。
 * 入力ステップの見出し / 確認ステップの項目 / 完了ステップの表示を
 * お問い合わせ（/contact）と MGK お申し込み（/mgk）で共有する。
 * 新しい「入力 → 確認 → 完了」型のフローもここから組む。
 */

// ===== 入力ステップ =====

export const StepFormTitle = styled.h2.attrs({ className: "heading-spacing-1824" })`
  margin-bottom: 8px;
  color: #000;
`;

export const StepFormDescription = styled.p.attrs({ className: "bodytext u-line-height-150" })`
  color: var(--soremo-light-gray);
  margin-bottom: 32px;
`;

export const StepFormGroup = styled.div`
  margin-bottom: 24px;
`;

/** Input/Select 以外の要素（Tab など）に付ける項目ラベル。Input の label と同じ見え方 */
export const StepFormLabel = styled.label.attrs({
  className: "bodytext-13 u-line-height-100 u-pl4",
})`
  display: block;
  margin-bottom: 8px;
`;

// ===== 確認ステップ =====

const ConfirmSection = styled.div`
  background-color: var(--soremo-background);
  border-radius: 6px;
  padding: 16px 24px;
  margin-bottom: 12px;
`;

const ConfirmLabel = styled.div.attrs({ className: "bodytext-11" })`
  color: var(--soremo-light-gray);
  margin-bottom: 4px;
`;

const ConfirmValue = styled.div.attrs({ className: "bodytext" })`
  color: #000;
  word-break: break-all;
  white-space: pre-wrap;
`;

export interface StepConfirmItemProps {
  label: string;
  /** 空のときは fallback（既定「未入力」）を表示 */
  value?: React.ReactNode;
  fallback?: string;
}

export const StepConfirmItem: React.FC<StepConfirmItemProps> = ({
  label,
  value,
  fallback = "未入力",
}) => (
  <ConfirmSection>
    <ConfirmLabel>{label}</ConfirmLabel>
    <ConfirmValue>{value === undefined || value === "" ? fallback : value}</ConfirmValue>
  </ConfirmSection>
);

// ===== 完了ステップ =====

const CompleteContainer = styled.div`
  text-align: center;
  padding: 48px 0;
`;

const CompleteIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: var(--soremo-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
`;

const CompleteIconText = styled.span.attrs({ className: "material-symbols-rounded" })`
  font-size: 40px;
  color: #fff;
`;

const CompleteTitle = styled.h2.attrs({ className: "heading-spacing-1824" })`
  color: var(--soremo-gray);
  margin-bottom: 16px;
`;

const CompleteMessage = styled.p.attrs({ className: "bodytext" })`
  color: var(--soremo-light-gray);
`;

export interface StepCompleteProps {
  title: string;
  children: React.ReactNode;
  icon?: string;
}

export const StepComplete: React.FC<StepCompleteProps> = ({ title, children, icon = "check" }) => (
  <CompleteContainer>
    <CompleteIcon>
      <CompleteIconText>{icon}</CompleteIconText>
    </CompleteIcon>
    <CompleteTitle>{title}</CompleteTitle>
    <CompleteMessage>{children}</CompleteMessage>
  </CompleteContainer>
);
